import { useState, useCallback, useEffect } from 'react';

const useTabState = initialTab => {
	const [activeTab, setActiveTab] = useState(initialTab);

	const handleTabChange = useCallback(
		(event, newValue) => {
			setActiveTab(newValue);
		},
		// eslint-disable-next-line
		[]
	);

	useEffect(
		() => {
			setActiveTab(initialTab);
		},
		// eslint-disable-next-line
		[initialTab]
	);

	return { activeTab, handleTabChange };
};

export default useTabState;
